import React from 'react'
import { Tooltip } from 'react-tooltip'

const handleAccessClick = (item) => {
    window.location.href = item;
}

const EmpresaGrupoCard = () => {
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-lg-4 mb-4" key={1}>
                                            <div className="dashboard-cards">
                                                <div className="card-item">
                                                    <div className="card-content-container">
                                                        <div className="card-content">
                                                            <h3>Sección grupo empresa</h3>

                                                            {/* Acortar texto y mostrar tooltip */}
                                                            <p
                                                                className="analytic-text"
                                                                data-tooltip-id={`desc-${1}`}
                                                                data-tooltip-content='Sección grupo empresa'
                                                            >
                                                                {
                                                                    'Sección grupo empresa'
                                                                }
                                                            </p>
                                                            <Tooltip
                                                                id={`desc-${1}`}
                                                                place="top"
                                                                effect="solid"
                                                                style={{
                                                                    backgroundColor: '#b3e5fc',  // Fondo celeste cálido
                                                                    color: '#000',               // Color del texto
                                                                    borderRadius: '12px',        // Bordes redondeados
                                                                    padding: '10px',             // Espaciado interno
                                                                    maxWidth: '200px',           // Limitar el ancho máximo del tooltip
                                                                    whiteSpace: 'normal',        // Permitir saltos de línea
                                                                    wordWrap: 'break-word',      // Ajustar texto largo
                                                                    textAlign: 'center',         // Centrar el texto
                                                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'  // Sombra para resaltarlo
                                                                }}
                                                            />

                                                        </div>
                                                    </div>
                                                    <button
                                                        className="access-btn"
                                                        onClick={() => handleAccessClick(global.GRUPOS_CREATE)}
                                                    >
                                                        Acceder
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-4 mb-4" key={1}>
                                            <div className="dashboard-cards">
                                                <div className="card-item">
                                                    <div className="card-content-container">
                                                        <div className="card-content">
                                                            <h3>Sección empresa</h3>

                                                            {/* Acortar texto y mostrar tooltip */}
                                                            <p
                                                                className="analytic-text"
                                                                data-tooltip-id={`desc-${1}`}
                                                                data-tooltip-content='Sección empresa'
                                                            >
                                                                {
                                                                    'Sección empresa'
                                                                }
                                                            </p>
                                                            <Tooltip
                                                                id={`desc-${1}`}
                                                                place="top"
                                                                effect="solid"
                                                                style={{
                                                                    backgroundColor: '#b3e5fc',  // Fondo celeste cálido
                                                                    color: '#000',               // Color del texto
                                                                    borderRadius: '12px',        // Bordes redondeados
                                                                    padding: '10px',             // Espaciado interno
                                                                    maxWidth: '200px',           // Limitar el ancho máximo del tooltip
                                                                    whiteSpace: 'normal',        // Permitir saltos de línea
                                                                    wordWrap: 'break-word',      // Ajustar texto largo
                                                                    textAlign: 'center',         // Centrar el texto
                                                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'  // Sombra para resaltarlo
                                                                }}
                                                            />

                                                        </div>
                                                    </div>
                                                    <button
                                                        className="access-btn"
                                                        onClick={() => handleAccessClick(global.EMPRESAS_CREATE)}
                                                    >
                                                        Acceder
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default EmpresaGrupoCard
